import { useStore } from 'zustand';

import { firstLoadedPageStore, isPrecachePage } from '../../../telemetry/firstLoadedPageStore';

export interface UseHasAppLoadedProps {
  /**
   * If true, the hook will return false if the first page rendered is 'Precache' or 'EmptyStart'.
   */
  readonly excludePrecacheLoad?: boolean;
}

type UseHasFirstPageLoaded = (props: UseHasAppLoadedProps) => boolean;
export const useHasFirstPageLoaded: UseHasFirstPageLoaded = ({ excludePrecacheLoad = false }) => {
  const firstLoadedPage = useStore(firstLoadedPageStore, (state) => state.firstLoadedPage);

  if (!firstLoadedPage) {
    return false;
  }

  if (excludePrecacheLoad && isPrecachePage(firstLoadedPage)) {
    return false;
  }

  return true;
};
